import { SettlementVatRatesSettingsDto } from 'types';
import { jsonObjectsTexts } from 'consts/text';
import { settlementVatRateTypeLabels } from 'consts/settlementVatRates/settlementVatRateLabels';
import { settlementVatReleaseReasonLabels } from 'consts/settlementVatRates/settlementVatReleaseReasonLabels';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';

export const parseSettlementVatRatesSettingsDTOIntoJsonObject: (
    settlementVatRatesSettingsDto: SettlementVatRatesSettingsDto,
) => object = (settlementVatRatesSettingsDto) => {
    const {
        stayVatRateType,
        mealVatRateType,
        starterKitVatRateType,
        stayVatReleaseReason,
        mealVatReleaseReason,
        starterKitVatReleaseReason,
        mealCustomVatReleaseReason,
        stayCustomVatReleaseReason,
        starterKitCustomVatReleaseReason,
    } = settlementVatRatesSettingsDto;

    const stayVatRateTypeLabel = settlementVatRateTypeLabels[stayVatRateType];
    const mealVatRateTypeLabel = settlementVatRateTypeLabels[mealVatRateType];
    const starterKitVatRateTypeLabel = settlementVatRateTypeLabels[starterKitVatRateType];
    const stayVatReleaseReasonLabel = stayVatReleaseReason
        ? settlementVatReleaseReasonLabels[stayVatReleaseReason]
        : EMPTY_VALUE_LABEL;
    const mealVatReleaseReasonLabel = mealVatReleaseReason
        ? settlementVatReleaseReasonLabels[mealVatReleaseReason]
        : EMPTY_VALUE_LABEL;
    const starterKitVatReleaseReasonLabel = starterKitVatReleaseReason
        ? settlementVatReleaseReasonLabels[starterKitVatReleaseReason]
        : EMPTY_VALUE_LABEL;

    return {
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.stayVatRateType]:
            stayVatRateTypeLabel,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.stayVatReleaseReason]:
            stayVatReleaseReasonLabel,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.customStayVatReleaseReason]:
            stayCustomVatReleaseReason || EMPTY_VALUE_LABEL,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.mealVatRateType]:
            mealVatRateTypeLabel,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.mealVatReleaseReason]:
            mealVatReleaseReasonLabel,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.customMealVatReleaseReason]:
            mealCustomVatReleaseReason || EMPTY_VALUE_LABEL,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.starterKitVatRateType]:
            starterKitVatRateTypeLabel,

        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.starterKitVatReleaseReason]:
            starterKitVatReleaseReasonLabel,
        [jsonObjectsTexts.settlementVatRatesSettingsDto.fields.customStarterKitVatReleaseReason]:
            starterKitCustomVatReleaseReason || EMPTY_VALUE_LABEL,
    };
};
